import React from "react";

import * as styles from "./styles";

export function Content({ children }: { children?: React.ReactNode }) {
  return (
    <div className={styles.container} data-testid="sidebar-container">
      <div className={styles.content} data-testid="sidebar-content">
        {children}
      </div>
    </div>
  );
}
